import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const SME_LOAN_URL = `${API_URL}/sme-loan-applications`

export const service = {
  getSmeLoanApplications: (params: ParamsModel) => {
    return axios.get(SME_LOAN_URL, {params})
  },
  getSmeLoanApplicationDetail: (md5Id: string) => {
    return axios.get(`${SME_LOAN_URL}/${md5Id}`)
  },
  updateSmeLoanStatus: (md5Id: string, status: string) => {
    return axios.patch(`${SME_LOAN_URL}/${md5Id}/status`, {status})
  },
}
